const KEY_PREFIX = 'popup:'

function blockedKey(popupId) {
  return `${KEY_PREFIX}${popupId}:blockedUntil`
}

function safeRead(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function safeWrite(key, value) {
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

function safeRemove(key) {
  try {
    localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

/**
 * Is this pop-up currently blocked from being shown?
 * @param {string} popupId
 * @returns {boolean}
 */
export function isBlocked(popupId) {
  const raw = safeRead(blockedKey(popupId))
  if (!raw) return false
  const until = Number(raw)
  if (Number.isNaN(until)) return false
  return Date.now() < until
}

/**
 * Mark this pop-up as blocked until a specific timestamp.
 * Pass Infinity to block forever.
 * @param {string} popupId
 * @param {number} until - timestamp (ms) or Infinity
 */
export function setBlockedUntil(popupId, until) {
  const value = until === Infinity ? String(Number.MAX_SAFE_INTEGER) : String(until)
  safeWrite(blockedKey(popupId), value)
}

/**
 * Remove the blocked marker for this pop-up.
 * @param {string} popupId
 */
export function clearBlocked(popupId) {
  safeRemove(blockedKey(popupId))
}
